<template>
  <div class="container">
    <h5>Songs in queue:</h5>
    <song-item v-for="song in songs" :key="song.id" :song="song"/>
  </div>
</template>

<script>
import SongItem from './SongItem'
export default {
  name: 'song-list',
  props: ['songs'],
  components: {SongItem},
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style type="scss" scoped>
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Rammetto+One');
  .container {
    font-family: 'Montserrat', sans-serif;
    padding-top: 20px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/SongList.vue